/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore', 'assets/js/modules/pricing/pricingModel', 'assets/js/modules/utils'], function(
    backbone,
    _,
    PricingModel,
    utils
) {
    return PricingModel.extend({
        defaults: {
            strategy: 'surcharge',
            productSlug: null,
            /** @var {SkuModel[]} productSkus */
            productSkus: []
        },

        initialize: function(options) {
            this.set('productSkus', new backbone.Collection());
        },

        /**
         * @param {Object} context
         * @returns {number}
         */
        getPrice: function(context) {
            var sku = context.sku;
            var pricingSetName = context.pricingSetName;

            var basePrice = sku.getPrice(pricingSetName);
            var targetSku = this.get('productSkus').findWhere({
                quantity: sku.get('quantity'),
                sides: sku.get('sides')
            });

            if (_.isUndefined(targetSku)) {
                return 0;
            }

            return utils.roundFloat(targetSku.getPrice(pricingSetName) - basePrice);
        },

        toString: function(context) {
            return '';
        }
    });
});
